const Wix = global.Wix;

export function logWidgetSystemBI(eventName) {
  const instanceId = _.attempt(Wix.Utils.getInstanceId);
  const visitorId =
    _.attempt(Wix.Utils.getUid) || _.attempt(Wix.Utils.getInstanceValue, 'aid');

  // Don't send events without instanceId
  if (
    !visitorId ||
    !instanceId ||
    _.isError(instanceId) ||
    _.isError(visitorId)
  ) {
    return;
  }

  const killer = Date.now();
  const compId =
    _.attempt(Wix.Utils.getOrigCompId) ||
    _.attempt(Wix.Utils.getCompId) ||
    'compId';
  const biToken = _.attempt(Wix.Utils.getInstanceValue, 'biToken');

  let url =
    '//frog.wix.com/video?src=71' +
    '&evid=232' +
    `&eventName=${eventName}` +
    `&compId=${compId}` +
    `&videoInstanceID=${instanceId}` +
    `&visitorID=${visitorId}` +
    `&_=${killer}`;

  if (biToken) {
    url = `${url}&biToken=${biToken}`;
  }

  if (!__DEBUG__) {
    const img = new Image();
    img.src = url;
  }
}
